/**
 * eRCMS.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { FileDto } from './fileDto';
import { TransmitStatus } from './transmitStatus';

export interface OutcomeDto { 
    id?: string;
    remark?: string;
    approved?: boolean;
    attachment?: FileDto;
    readonly documentSizeKb?: number;
    transmitStatus?: TransmitStatus;
    isShared?: boolean;
    decisionDate?: Date;
}